import React, { useState } from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import Link from 'next/link';

import Typography from '../../atoms/typography';
import CategoryList, { Category } from '../../molecules/filter-category-list';
import { getBasePath } from '../../utils/navigation';
import SLIHyphenMap from '../../utils/SLIHyphenMap.json';

const Heading = styled(Typography)`
  border-bottom: 1px solid ${(props) => props.theme.color.brand};
  color: ${(props) => props.theme.color.brand};
  display: flex;
  flex-direction: column;
  justify-content: center;
  letter-spacing: 0.2rem;
  margin-bottom: 1rem;
  min-height: 4rem;
  text-transform: uppercase;
`;

const Categories = styled.section`
  display: none;
  margin-bottom: 0;

  @media (min-width: ${(props) => props.theme.breakpoint.medium}) {
    display: block;
  }

  ol ol {
    margin-left: 2rem;
  }
`;

const MAX_NUMBER_CATS = 7;

const FacetBreadcrumbs = (props) => {
  const [showMore, setShowMore] = useState(false);

  const getHrefValue = (cats = null) => {
    const base = getBasePath(props).split('?')[0];
    return cats ? `${base}/${cats?.map((x) => SLIHyphenMap[x] ?? x)?.join('/')}` : base;
  };

  return (
    <Categories>
      <Heading element="h2" like="label-1">Categories</Heading>
      <ol>
        <li>
          <Link href={getHrefValue()} passHref>
            <Category element="a" like="dec-1" active={!props.categories?.active ? 'true' : undefined}>All</Category>
          </Link>
        </li>

        {
          props.categories?.defaults?.[0]?.values
            ?.slice(0, MAX_NUMBER_CATS)
            ?.map((cat1) => (
              <CategoryList
                key={cat1?.id}
                cat1={cat1}
                categories={props.categories}
                getHrefValue={getHrefValue}
              />
            ))
        }

        {
          !showMore
          && props.categories?.defaults?.[0]?.values?.slice(
            MAX_NUMBER_CATS, props.categories?.defaults?.[0]?.values?.length
            ).length > 0 && (
              <Category element="span" like="dec-1" onClick={() => setShowMore(true)}>
                Show All...
              </Category>
          )
        }

        {
          showMore
          && props.categories?.defaults?.[0]?.values
            ?.slice(MAX_NUMBER_CATS, props.categories?.defaults?.[0]?.values?.length)
            ?.map((cat1) => (
              <CategoryList
                key={cat1?.id}
                cat1={cat1}
                categories={props.categories}
                getHrefValue={getHrefValue}
              />
            ))
        }

      </ol>
    </Categories>
  );
};

FacetBreadcrumbs.propTypes = {
  categories: PropTypes.object.isRequired
};

export default FacetBreadcrumbs;
